export const BLACKLISTED_MIME_TYPES = new Set(['application/pkcs7-signature'])

export const ARCHIVE_EXTENSIONS = new Set(['ZIP', 'RAR', 'ICS', '7Z'])

export const ARCHIVE_MIME_TYPES = new Set([
  'application/zip',
  'application/x-zip-compressed',
  'application/x-rar-compressed',
  'application/x-7z-compressed',
])

export const VIDEO_EXTENSIONS = new Set(['MP4', 'MOV'])

export const VIDEO_MIME_TYPES = new Set(['video/mp4', 'video/quicktime'])

export const MIME_TYPE_LABEL_MAP = new Map<string, string>([
  ['application/pdf', 'PDF'],
  ['application/msword', 'DOC'],
  [
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'DOCX',
  ],
  [
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    'DOTX',
  ],
  ['application/vnd.ms-excel', 'XLS'],
  ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'XLSX'],
  [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
    'XLTX',
  ],
  ['text/plain', 'TXT'],
  ['text/csv', 'CSV'],
  ['application/json', 'JSON'],
  ['application/zip', 'ZIP'],
  ['application/x-zip-compressed', 'ZIP'],
  ['application/x-7z-compressed', '7Z'],
  ['application/x-rar-compressed', 'RAR'],
  ['application/vnd.ms-powerpoint', 'PPT'],
  [
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'PPTX',
  ],
  [
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
    'PPSX',
  ],
  ['application/vnd.ms-outlook', 'MSG'],
])

export const DEFAULT_FILE_TYPE = 'FILE'
